import React from "react";

export function textWithLineBreaks(text: string): React.ReactNode {
  if (typeof text !== "string") {
    return text;
  }

  const lines = text.split("\n");
  return lines.map((line, i) => (
    <React.Fragment key={i}>
      {line}
      {i < lines.length - 1 && <br />}
    </React.Fragment>
  ));
}
